module.exports = __webpack_public_path__ + "img/nlogo2.7980def2.png";